export default __webpack_public_path__ + "static/media/logo-irta.c2c77ddf.png";